module.exports = __webpack_public_path__ + "static/media/one-of-a-kind.4903045a.webp";